import { stateKeys, actions } from '../../model';
import { readFile } from '../../utils/readFile';

const { setFileData, setErr } = actions;

export const fileDataHandler = async (data, dispatch) => {
  if (!data) return;

  try {
    const src = await readFile(data.file);

    dispatch(setFileData({ ...data, [stateKeys.fileSrc]: src }));
  } catch (error) {
    dispatch(setErr(['Не удалось прочитать выбранный файл']));
  }
};
